import { render, staticRenderFns } from "./SpThreeModule2.vue?vue&type=template&id=a3d8c7be&scoped=true"
import script from "./SpThreeModule2.vue?vue&type=script&lang=js"
export * from "./SpThreeModule2.vue?vue&type=script&lang=js"
import style0 from "./SpThreeModule2.vue?vue&type=style&index=0&id=a3d8c7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d8c7be",
  null
  
)

export default component.exports